var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "icon-panel" }, [
        _c("div", { staticClass: "uploader" }, [
          _c("div", { staticClass: "clickable" }, [
            _c("label", [
              _vm._m(0),
              _c("span", { staticClass: "imguploadTit" }, [_vm._v("选择ICON")]),
              _c("span", { staticClass: "imguploadTit" }, [
                _vm._v("图片格式：PNG"),
              ]),
              _c("span", { staticClass: "imguploadTit" }, [
                _vm._v("512*512像素"),
              ]),
              _c("input", {
                attrs: { name: "iconFile", title: "添加图片", type: "file" },
                on: {
                  change: function ($event) {
                    return _vm.bundleFilePreview($event)
                  },
                },
              }),
            ]),
          ]),
        ]),
        _c("div", { staticStyle: { float: "left", "margin-left": "10px" } }, [
          _vm.previewShowed
            ? _c(
                "div",
                {
                  staticClass: "iconpreview icon-size",
                  attrs: { id: "iconPreview" },
                },
                [
                  _c("img", { attrs: { src: _vm.previewImgUrl } }),
                  _c("div", { staticClass: "mask-inner" }, [
                    _c("i", {
                      staticClass: "el-icon-delete",
                      on: { click: _vm.onDeleteClicked },
                    }),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "addImgBtn" }, [
      _c("i", { staticClass: "el-icon-circle-plus" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }